module.exports = __webpack_public_path__ + "static/media/1.af029b94.png";